var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.834 18.962a.73.73 0 0 1-.285-.46q-.045-.284.101-.706l1.956-5.877L.565 8.283q-.358-.249-.487-.505a.73.73 0 0 1-.046-.542.67.67 0 0 1 .35-.395q.256-.138.706-.138h6.19L9.16.826q.147-.422.349-.624a.694.694 0 0 1 .983 0q.21.203.348.624l1.883 5.877h6.198q.44 0 .698.138a.67.67 0 0 1 .349.395.73.73 0 0 1-.046.542q-.129.257-.487.505l-5.041 3.636 1.965 5.877q.138.422.083.707a.7.7 0 0 1-.276.459.64.64 0 0 1-.523.12q-.285-.047-.634-.294l-5.014-3.674-5.004 3.674q-.35.248-.643.293a.62.62 0 0 1-.514-.119"
  })));
};
export default SvgStar;